import SeoHead from './SeoHead';

interface WeddingHeadProps {
  title?: string;
  description?: string;
  imageUrl?: string;
  canonicalUrl?: string;
  noindex?: boolean;
}

const WeddingHead = ({
  title = 'Real Weddings - Zola',
  description = 'Browse gorgeous wedding photos from real Zola couples, and find ideas, venues, vendors, and more for your special day.',
  imageUrl = '',
  canonicalUrl,
  noindex = false,
}: WeddingHeadProps): JSX.Element => (
  <SeoHead
    title={title}
    description={description}
    imageUrl={imageUrl}
    canonicalUrl={canonicalUrl}
    noindex={noindex}
  />
);

export default WeddingHead;
